<template>
  <div id="q-app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',

  data () {
    return {
      queryLastPath: null
    }
  },

  watch: {
    $route (to, from) {
      if (to?.fullPath?.includes('login')) {
        this.queryLastPath = from?.fullPath || '/'
      } else {
        this.queryLastPath = to?.fullPath || '/'
      }
    }
  },

  beforeMount () {
    window.addEventListener('offline', () => {
      this.$q.notify({
        timeout: 3000,
        type: 'negative',
        color: 'negative',
        message: 'Internet Disconnected'
      })
    })
    window.addEventListener('online', () => {
      this.$q.notify({
        timeout: 3000,
        type: 'positive',
        color: 'positive',
        message: 'Internet Connected'
      })
    })
  },

  mounted () {
    setTimeout(() => {
      this.queryLastPath = this.$router?.currentRoute?.fullPath || '/'
    }, 1000)

    window.addEventListener('storage', (event) => {
      if (event.key === 'force-reload-key') {
        location.reload(true)
      }

      if (event.key === 'force-reload-key-path') {
        window.location.href = '/login?redirect_to=' + this.queryLastPath
      }

      if (event.key === 'force-reload-login') {
        if (this.$route?.query?.redirect_to) {
          window.location.href = this.$route?.query?.redirect_to
        } else {
          location.reload(true)
        }
      }
    })
  }
}
</script>
